import { render, staticRenderFns } from "./sharing.vue?vue&type=template&id=0f5084d7&lang=pug&"
import script from "./sharing.vue?vue&type=script&lang=js&"
export * from "./sharing.vue?vue&type=script&lang=js&"
import style0 from "./sharing.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f5084d7')) {
      api.createRecord('0f5084d7', component.options)
    } else {
      api.reload('0f5084d7', component.options)
    }
    module.hot.accept("./sharing.vue?vue&type=template&id=0f5084d7&lang=pug&", function () {
      api.rerender('0f5084d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/sharing.vue"
export default component.exports